import Input from 'library/components/form/input';
import { Content } from './styles';
import withFormContainer from './hocs/with-form-container';

const InputModal = ({ fieldKey = 'name', ...props }) => (
  <Content>
    <Input {...props} required name={fieldKey} />
  </Content>
);

export default withFormContainer(InputModal);
